/* eslint-disable react-hooks/exhaustive-deps */
//React imports
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
//Redux imports
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import {
  ownerAccountsViewAll,
  resetpage,
  resetToggle,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
//Component imports
import BalanceSummary from "../../../../components/_utils/CommonBalanceSummary";
import TertiaryTopRoundButton from "../../../../components/_utils/CommonButtons/TertiaryTopRoundButton/TertiaryTopRoundButton";
import TopBarButtons from "../../../../components/_utils/CommonButtons/TopBarButton";
import CommonCardDashboard from "../../../../components/_utils/CommonCardDashboard";
import CommonMoreActionsCard from "../../../../components/_utils/CommonMoreActionsCard";
//Utils imports
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import globalText from "../../../../utils/globalText";
import ICONS from "../../../../assets/Icons";
import NotificationBell from "../../../../components/Notification/NotificationBell";
import useInitials from "../../../../utils/useInitials";

function OwnerAccountDashboard() {
  // Dispatches dashboard requests and resets to the Redux store.
  const dispatch = useDispatch();
  // Route changes take the owner to dashboards and feature access notices.
  const navigate = useNavigate();
  // get initials for responsive top right
  const initials = useInitials();
  // Tracks which statistics slide is currently selected.
  const [currentSlide, setCurrentSlide] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  // Holds the summary and account counts returned for the dashboard.
  const [dashboardOwnersData, setDashboardOwnersData] = useState([]);

  // Services granted to the current user, used to gate dashboard actions.
  const services = useSelector((state) => state.refreshToken.services);
  // Active entity marker; changes trigger a refresh for the selected entity.
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  // Loading state for the owner account list request.
  const { ownerViewAllListAccLoading } = useSelector(
    (state) => state.ownerAllVerification,
  );

  // Available statistics slides; currently empty until statistics are provided.
  const slides = Array.from(
    { length: GlobalConfiguration.lengthCheckZero },
    (_, i) => `Slide ${i + GlobalConfiguration.lengthCheckOne}`,
  );

  // Uses zero as the fallback when the account response has no total count.
  const totalCount =
    dashboardOwnersData?.total_count ?? GlobalConfiguration?.lengthCheckZero;

  // Prevents View all while loading, without VAccount access, or with no accounts.
  const isViewAllDisabled =
    ownerViewAllListAccLoading ||
    !services?.includes("VAccount") ||
    totalCount === GlobalConfiguration?.lengthCheckZero;

  // Advances the statistics carousel when another slide is available.
  const nextSlide = () => {
    if (currentSlide < slides.length - GlobalConfiguration?.lengthCheckOne) {
      setCurrentSlide(currentSlide + GlobalConfiguration?.lengthCheckOne);
    }
  };
  // Moves the statistics carousel back when it is not on the first slide.
  const prevSlide = () => {
    if (currentSlide > GlobalConfiguration?.lengthCheckZero) {
      setCurrentSlide(currentSlide - GlobalConfiguration?.lengthCheckOne);
    }
  };

  // Fetches the first page of owner accounts and handles missing feature access.
  const getDashboardData = async () => {
    try {
      const response = await dispatch(
        ownerAccountsViewAll({
          page_no: GlobalConfiguration.lengthCheckOne,
          page_size: PaginationConfiguration.paginationSmall,
        }),
      );

      setDashboardOwnersData(response?.payload);

      if (
        response?.payload?.response?.data?.errors?.user_unauthorized?.length >
        GlobalConfiguration?.lengthCheckZero
      ) {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "VAccount" },
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Resets list filters and opens the account list for the selected status.
  const handleDatacardClick = (approvalStatus) => {
    dispatch(resetToggle());
    dispatch(resetpage());
    // Each dashboard status opens the shared account list with its status filter.
    const routeMap = {
      Active: "/owner_account_dashboard/owner_accounts_view_all",
      Inactive: "/owner_account_dashboard/owner_accounts_view_all",
      approved: "/owner_account_dashboard/owner_accounts_view_all",
      pending: "/owner_account_dashboard/owner_accounts_view_all",
      denied: "/owner_account_dashboard/owner_accounts_view_all",
      blocked: "/owner_account_dashboard/owner_accounts_view_all",
    };

    navigate(routeMap[approvalStatus], {
      state: { approvalStatus },
    });
  };

  // Enables entity switching on entry, reloads data when the entity changes,
  // and disables switching when the dashboard unmounts.
  useEffect(() => {
    dispatch(enableSwitcher());
    (async () => {
      await getDashboardData();
    })();
    return () => {
      dispatch(disableSwitcher());
    };
  }, [markerData]);

  return (
    <div className="bg-primary-bg w-width-full px-padding-md  overflow-y-auto lg:px-padding-base pb-padding-md h-screen overflow-x-hidden">
      <div className="Qsmd:h-navbar-breadcrumb-height"></div>

      <div className="flex flex-col gap-gap-md mt-margin-md lg:mx-auto pb-padding-xl lg:pb-padding-base max-w-tab-width-normal w-width-full Qlg:flex-row  mb-margin-xl lg:mb-margin-base Qlg:relative">
        <div className="w-width-full lg:w-width-lg flex flex-col pt-padding-lg Qsmd:pt-padding-base mt-margin-xl Qsmd:mt-margin-base ">
          {/* For mobile view, the owner account header is fixed at the top of the screen. starts here*/}
          <div className="Qsmd:hidden w-width-full fixed top-top-base left-left-base right-right-base bg-text-primary flex items-center justify-between z-z-index-fixed-ui rounded-b-border-radius-sm h-[var(--home-nav-mobile-height)] pl-mobile-padding-l pr-mobile-padding-l border-b border-primary-bg shadow-sm">
            <div className="flex items-center">
              <img
                src={ICONS?.XPENTRA_BLUE}
                alt="Xpentra Logo"
                className="w-xpentra-logo-width h-xpentra-logo-height"
              />
            </div>
            <div className="flex gap-gap-sm flex-row items-center ">
              <NotificationBell />
              <div className="w-px h-5 bg-primary-card mx-2"></div>
              <div
                className="text-xs bg-text-secondary text-primary-bg h-[var(--profile-initials-w-h)] w-[var(--profile-initials-w-h)] flex items-center justify-center rounded-full font-semibold cursor-pointer"
                onClick={() => navigate("/home/profile_quick_menu")}
              >
                {initials}
              </div>
            </div>
          </div>
          {/* Mobile view ends here */}

          <TopBarButtons
            services={services}
            items={[
              {
                imgColor: "var(--text-primary)",
                icon: ICONS?.VIEW_STATEMENT,
                label: (
                  <>
                    {globalText.UPLOAD_BANK}
                    <br />
                    {globalText.STATEMENT}
                  </>
                ),
                requiredservice: ["CStatementUpload"],
                onClick: () => {
                  if (!services?.includes("CStatementUpload")) {
                    navigate("/feature_not_assigned", {
                      state: {
                        unavailableService: "CStatementUpload",
                      },
                    });
                  } else {
                    navigate(
                      "/owner_account_dashboard/upload_bulk_bank_statement",
                    );
                  }
                },
              },
              {
                imgColor: "var(--text-primary)",
                icon: ICONS?.VIEW_CONSOLIDATED_STATEMENT,
                label: (
                  <>
                    Consolidated bank
                    <br />
                    {globalText.STATEMENT}
                  </>
                ),
                requiredservice: ["VAccountBalance" || "Admin"],
                onClick: (e) => {
                  if (
                    services?.includes("VAccountBalance") ||
                    services?.includes("Admin")
                  ) {
                    dispatch(resetToggle());
                    dispatch(resetpage());
                    navigate(
                      "/owner_account_dashboard/consolidated_bank_statement",
                    );
                  } else {
                    e.stopPropagation();
                    navigate("/feature_not_assigned", {
                      state: {
                        unavailableService: "VAccountBalance,Admin",
                      },
                    });
                  }
                },
              },
              {
                icon: ICONS?.LIVE_STATEMENT,
                label: (
                  <>
                    {globalText.CONSOLIDATED_LIVE}
                    <br />
                    {globalText.STATEMENT}
                  </>
                ),
                requiredservice: ["VItemisedStatement" || "Admin"],
                onClick: (e) => {
                  if (
                    services?.includes("VItemisedStatement") ||
                    services?.includes("Admin")
                  ) {
                    dispatch(resetToggle());
                    dispatch(resetpage());
                    navigate(
                      "/owner_account_dashboard/consolidated_live_statement",
                    );
                  } else {
                    e.stopPropagation();
                    navigate("/feature_not_assigned", {
                      state: {
                        unavailableService: "VItemisedStatement,Admin",
                      },
                    });
                  }
                },
              },
            ]}
          />

          <div className="w-width-full lg:mt-margin-md md:mt-margin-md sm:mt-margin-md mt-margin-md rounded-border-radius-md relative overflow-hidden">
            <h2 className="bg-primary-card flex items-center justify-between pl-padding-md transition-all duration-animation-medium">
              <div className="flex items-center gap-gap-sm">
                <img
                  src={ICONS?.APPROVAL_STATUS}
                  alt="transaction header"
                  className="w-icon-sm"
                />
                <p className="text-font-sm font-semibold font-sans text-text-secondary">
                  Account statuses
                </p>
              </div>
              <div className="flex">
                <div className="border-dividing"></div>

                <TertiaryTopRoundButton
                  btnText="View all"
                  icon={ICONS?.ARROW_RIGHT_WHITE}
                  imgColor="var(--text-primary)"
                  btnType="button"
                  hoverOption="white"
                  handleFunction={async () => {
                    if (isViewAllDisabled) return;
                    await dispatch(resetpage());
                    await dispatch(resetToggle());
                    navigate(
                      "/owner_account_dashboard/owner_accounts_view_all",
                    );
                  }}
                  isDisabled={isViewAllDisabled}
                  isLoading={ownerViewAllListAccLoading}
                  enabledTextColor={"var(--text-primary)"}
                  enabledBgColor={"var(--primary-card)"}
                  disabledBgColor={"transparent"}
                />
              </div>
            </h2>
            <div>
              <div className="flex flex-col Qsmd:flex-row gap-gap-base p-padding-base bg-primary-nav">
                <CommonCardDashboard
                  label="Active accounts"
                  count={
                    dashboardOwnersData?.summary?.connected_banking_count ??
                    "00"
                  }
                  color="var(--settled)"
                  loader={ownerViewAllListAccLoading}
                  onClick={() => handleDatacardClick("Active")}
                  onServiceUnavailable={() =>
                    navigate("/feature_not_assigned", {
                      state: { unavailableService: "VAccount" },
                    })
                  }
                />
                <div className="border-border border-primary-bg Qsmd:my-margin-md my-margin-base "></div>
                <CommonCardDashboard
                  label="Inactive accounts"
                  count={
                    dashboardOwnersData?.summary?.non_connected_banking_count ??
                    "00"
                  }
                  color="var(--failed)"
                  loader={ownerViewAllListAccLoading}
                  onClick={() => handleDatacardClick("Inactive")}
                  onServiceUnavailable={() =>
                    navigate("/feature_not_assigned", {
                      state: { unavailableService: "VAccount" },
                    })
                  }
                />
              </div>
            </div>
          </div>

          <div className="w-width-full mt-margin-md bg-primary-nav rounded-t-border-radius-md rounded-b-border-radius-md">
            <h2 className="bg-primary-card flex items-center justify-between px-padding-md py-padding-sm text-sm font-semibold text-text-secondary transition-all duration-animation-medium rounded-t-border-radius-md">
              <span className="flex items-center text-sm font-semibold text-text-secondary ">
                <img
                  src={ICONS?.STATISTICS}
                  alt="Statistics Header"
                  className="h-icon-sm mr-margin-sm"
                />
                Statistics
              </span>
              {slides.length > GlobalConfiguration?.lengthCheckZero && (
                <div className="flex items-center mx-margin-sm">
                  <div
                    onClick={prevSlide}
                    className={`cursor-pointer w-icon-sm h-icon-sm flex items-center justify-center ${
                      currentSlide === GlobalConfiguration?.lengthCheckZero
                        ? "opacity-light-opacity cursor-not-allowed"
                        : ""
                    }`}
                    style={{
                      pointerEvents:
                        currentSlide === GlobalConfiguration?.lengthCheckZero
                          ? "none"
                          : "auto",
                    }}
                  >
                    <img
                      alt="Previous"
                      className="w-width-full h-height-full"
                    />
                  </div>
                  <div
                    onClick={nextSlide}
                    className={`cursor-pointer w-icon-sm h-icon-sm flex items-center justify-center ${
                      currentSlide ===
                      slides.length - GlobalConfiguration?.lengthCheckOne
                        ? "opacity-light-opacity cursor-not-allowed"
                        : ""
                    }`}
                    style={{
                      pointerEvents:
                        currentSlide ===
                        slides.length - GlobalConfiguration?.lengthCheckOne
                          ? "none"
                          : "auto",
                    }}
                  >
                    <img
                      alt="Next"
                      className="w-width-full h-height-full"
                    />
                  </div>
                </div>
              )}
            </h2>

            <div className="relative w-width-full Qlg:py-padding-md overflow-hidden contents Qlg:block ">
              {slides.length > GlobalConfiguration?.lengthCheckZero ? (
                <div
                  className="flex transition-transform duration-animation-medium ease-in-out"
                  style={{
                    transform: `translateX(-${currentSlide * PaginationConfiguration.paginationBig}%)`,
                  }}
                >
                  {slides.map((slide, index) => (
                    <div className="w-width-full flex-shrink-0 flex items-center justify-center">
                      {slide}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center lg:justify-start h-height-full text-center p-padding-md">
                  <div className="flex flex-col justify-center items-center w-width-full gap-gap-sm">
                    <img
                      src={ICONS?.NO_STATISTICS_AVAILABLE}
                      alt="No Slides"
                    />
                    <p className="text-font-xs text-text-primary">
                      No statistics available due to the absence of data.
                      <br />
                      Once data is present, statistics will appear.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex flex-col Qlg:w-width-sm gap-y-gap-md">
          <BalanceSummary />
          <CommonMoreActionsCard
            title="More actions"
            actions={[
              {
                label: "MIS report",
                service: "SMisUser",
                onClick: () => {
                  if (services?.includes("SMisUser")) {
                    navigate("/owner_account_dashboard/generate_mis_report");
                  } else {
                    navigate("/feature_not_assigned", {
                      state: {
                        unavailableService: "SMisUser",
                      },
                    });
                  }
                },
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
}

export default OwnerAccountDashboard;
